
import { useEffect } from "react"
import TablaBienesServicios from "../../../../EmitirFactura/Components/GeneracionFactura/TablaBienesServicios"
import Footer from "../../Footer"
import ViewDocV1 from "../forms/ViewDocV1"
import { useDispatch, useSelector } from "react-redux"
import { State } from "../../../../../reducers"

import { facturacionArrayProductosSet, facturacionSetTotalDocRelacionado } from "../../../../../actions/facturacion/facturacionProductos.actions"
import { ProductosF } from "../../../../../interfaces/facturacion.interface"
import { descuentoGlobalPorItem, redondear2 } from "../../../../../utils/descuentoGlobal"
import { alcanzaElMinimoDelUnoPorCiento, unoPorCiento } from "../../../../../utils/calculo-dte"
import { calculoDeLinea } from "../../../../../utils/calculo-otros-documentos"
import FormProductosV1 from "../forms/productos/FormProductosV1"

export const NotaCredito = () => {
  const {activeFactura} = useSelector((state: State) => state.historial);
  const {activeDoc} = useSelector((state: State) => state.documentos);
  const {arrayProductos, calculosArrayProductos} = useSelector((state: State) => state.facturacion);
  const dispatch = useDispatch();

  useEffect(() => {
    setTimeout(() => {
      if (arrayProductos.length > 0) { return; }
      
      // Cargar productos
      const cuerpo = activeFactura?.DetallesDTE?.cuerpoDocumento;
      let productos = [];
      
      if (Array.isArray(cuerpo)) productos = cuerpo;
      else productos = [cuerpo];

      // Si el documento tuvo descuento global, se suma al descuento por item de cada producto
      const descuentosGlobales = descuentoGlobalPorItem(productos, activeFactura?.DetallesDTE?.resumen);

      const lineas = productos?.map((producto: any, indice: number) => {
        const descuentoItem = redondear2((parseFloat(producto?.montoDescu) || 0) + (descuentosGlobales[indice] || 0));
        return {
          producto,
          calculo: calculoDeLinea({
            precio: producto?.precioUni,
            cantidad: producto?.cantidad,
            tipoDescuento: 'Monto',
            descuento: descuentoItem,
          }),
        }
      })

      const sumaOperaciones = redondear2(lineas.reduce((acumulado: number, linea: any) => acumulado + linea.calculo.subtotal, 0));
      const aplicaRetencion = alcanzaElMinimoDelUnoPorCiento(sumaOperaciones);

      const productosList:Array<ProductosF> = lineas?.map(({producto, calculo}: any) => {
        const {neto, descuento, subtotal, iva} = calculo;
        const totalConImpuesto1 = redondear2(neto + iva);
        const retencion = aplicaRetencion ? unoPorCiento(subtotal) : 0;

        return {
          descripcion: producto?.descripcion+"", 
          cantidad: producto?.cantidad+"",
          precio: producto?.precioUni+"",
          tipoDescuento: "monto",
          descuento: descuento+"",
          cantidadDescuento: descuento+"",
          subtotal: neto.toFixed(2),
          total: subtotal.toFixed(2),
          totalImpuesto1: iva.toFixed(2),
          totalImpuesto2: retencion ? retencion.toFixed(2) : "0.00",
          impuesto1: "13",
          impuesto2: retencion ? "1" : "0",
          totalConImpuesto1: totalConImpuesto1.toFixed(2),
          subTotalConImpuesto1: "0.00",
          totalConImpuesto1Desc: redondear2(totalConImpuesto1 - descuento).toFixed(2),
        }
      })

      dispatch(facturacionArrayProductosSet(productosList));
    }, 1000)
  }, []);

  useEffect(() => {
    if (!calculosArrayProductos.totalDocRelacionado && calculosArrayProductos.totalConRetecion !== "0.00") {
      dispatch(facturacionSetTotalDocRelacionado(calculosArrayProductos.totalConRetecion));
    }
  }, [calculosArrayProductos]);

  return (
    <>
      <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
        <div className='card w-form' style={{textAlign: 'center'}}>
          <label>DOCUMENTO DE REFERENCIA</label>
          <p>{activeFactura?.DetallesDTE?.identificacion?.numeroControl ?? "---"}</p>
        </div>   
      </div>
      <ViewDocV1 />
      <FormProductosV1 doc="5" />
      <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
        <div className='card'>
          <div className='w-layout-vflex card-content'>
            <TablaBienesServicios />
            <Footer />
          </div>
        </div>
      </div>
    </>
  )
}